import { createSlice } from '@reduxjs/toolkit';

import { ITouristRoutessState } from './interfaces';
import { loadTouristRoutesItem, loadTouristRoutesList } from './actions';

export const touristRoutesSlice = createSlice({
  name: 'touristRoutes',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
    isLoading: false,
  } as ITouristRoutessState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadTouristRoutesList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
        state.isLoading = false;
      }
    );
    builder.addCase(loadTouristRoutesList.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(loadTouristRoutesList.rejected, state => {
      state.isLoading = false;
    });
    builder.addCase(loadTouristRoutesItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
